import { render, staticRenderFns } from "./ChangeTransactionCategoryPopup.vue?vue&type=template&id=47255192"
import script from "./ChangeTransactionCategoryPopup.vue?vue&type=script&lang=js"
export * from "./ChangeTransactionCategoryPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangeTransactionCategoryPopup.vue?vue&type=style&index=0&id=47255192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports